module.exports = __webpack_public_path__ + "static/media/result.a5df2233.gif";